//CSS
//import materializeCSS from 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/css/materialize.min.css';

// 1) Import ReactDOM library
import ReactDOM from "react-dom/client";
// 2) Import App component as usual
import App from './components/App';

// redux
import { Provider } from "react-redux";
import {createStore, applyMiddleware} from 'redux';
import reducers from "./reducers";
import reduxThunk from 'redux-thunk';

// test mailer, temporary
import axios from 'axios';
window.axios = axios;
// const survey = { title: 'my title', subject: 'my subject', recipients: 'dominik.skorupski1@gmail.com', body: 'body of email'};
// axios.post('/api/surveys', survey); type voth in console log to test axios from chrome dev

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));



// 3) Get a reference to the div with ID root
const el = document.getElementById("root");
// 4) Tell React to take control of that element
const root = ReactDOM.createRoot(el);
// 5) Show the component on the screen
root.render(
    <Provider store={store}>
        <App />
    </Provider>,
);

// console.log(process.env.REACT_APP_STRIPE_KEY); // check env variables in client to use them
// console.log(process.env.NODE_ENV); // check env